import { Tooltip, TooltipContent, TooltipTrigger, cn } from "@nexus/ui";

/** Wraps long cell copy so the full string is reachable via hover tooltip. */
export function ExpandableCellText({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={className}>{text}</span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-sm whitespace-normal break-words text-left">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}

export function DrivenFeatureCell({
  text,
  isDriven,
  drivenLabel,
}: {
  text: string;
  isDriven: boolean;
  drivenLabel: string;
}) {
  return (
    <div className="space-y-1">
      {isDriven ? (
        <span className="inline-flex rounded-sm bg-primary/10 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-primary">
          {drivenLabel}
        </span>
      ) : null}
      <ExpandableCellText
        text={text}
        className={cn(
          "line-clamp-3 whitespace-normal break-words",
          isDriven && "font-semibold text-foreground",
        )}
      />
    </div>
  );
}
